// extracted by mini-css-extract-plugin
module.exports = {"richTextContainer":"login_richTextContainer__6HA27","registerNowContainer":"login_registerNowContainer__hKKuL"};